import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  linkActive: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)'
  }
}));